import {
  Resources,
  WorkflowTemplateType,
  WorkflowTemplatesAdapter,
} from "@validereinc/domain";
import { useGetList, useGetOne, useUpdateOne } from "./adapterUtils";

export const useGetOneWorkflowTemplate = useGetOne<WorkflowTemplateType>(
  WorkflowTemplatesAdapter.getOne,
  Resources.WORKFLOW_TEMPLATE
);

export const useUpdateWorkflowTemplate = useUpdateOne<WorkflowTemplateType>(
  WorkflowTemplatesAdapter.updateOne,
  Resources.WORKFLOW_TEMPLATE
);

export const useListWorkflowTemplates = useGetList(
  WorkflowTemplatesAdapter.getList,
  Resources.WORKFLOW_TEMPLATE
);
